
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rss.xml",
      function () {
        return require("private-next-pages/rss.xml.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rss.xml"])
      });
    }
  